// import {rawDataApi} from "@/axios";

export const modelInfo = [

    {
        name: '交付系统',
        webUrl: '/',
        api:{
            name:'deliveryApi',
            url:'/delivery_api',
        },
        isOverview:false,
    },  {
        name: '多样性交付系统',
        webUrl: '/projectBz',
        api:{
            name:'bzApi',
            url:'/bz_api',
        },
        isOverview:true,
    }, {
        name: '功能基因扩增子交付系统',
        webUrl: '/projectBzFun',
        api:{
            name:'bzApi',
            url:'/bz_api',
        },
        isOverview:true,
    }, {
        name: '宏基因组系统',
        webUrl: '/projectMetag',
        api:{
            name:'metagApi',
            url:'/metag_api_v3',
        },
        isOverview:true,
    },
    {
        name: '转录组系统',
        webUrl:'/projectTrans',
        api:{
            name:'transApi',
            url:'/trans_api',
        },
        isOverview:true,
    }
    , {
        name: '代谢组系统',
        webUrl: '/projectMetabo',
        api:{
            name:'metaboApi',
            url:'/metabo_api',
        },
        isOverview:true,
    },
    {
        name: '项目交付中心',
        webUrl: '/',
        api:{
            name:'platformApi',
            url:'/project_center_api',
        },
        isOverview:false,
    }, {
        name: '转录和代谢联合分析交付系统',
        webUrl: '/projectTransMetabo',
        api:{
            name:'transMetaboApi',
            url:'/trans_metabo_api',
        },
        isOverview:true,
    },
    {
        name: '多样性和代谢联合分析交付系统',
        webUrl: '/projectBzMetabo',
        api:{
            name:'bzMetaboApi',
            url:'/amp_metabo_api',
        },
        isOverview:true,
    },
    {
        name: '裸测项目交付系统',
        webUrl:'/nakedRawData',
        api:{
            name:'nakedApi',
            url:'/naked_api',
        },
        isOverview:true,
    },
    {
        name: '其他类型项目交付系统',
        webUrl: '/projectRawData',
        api:{
            name:'rawDataApi',
            url:'/raw/prod-api',
        },
        isOverview:true,
    },
    {
        name: '单细胞交付系统',
        webUrl: '/projectSingleCell',
        api:{
            name:'singleCellApi',
            url:'/single_cell_api',
        },
        isOverview:true,
    },
    {
        name: '鱼类eDNA交付系统',
        webUrl: '/projectEDNA',
        api:{
            name:'eDNAApi',
            url:'/fish_edna_api',
        },
        isOverview:true,
    },

]
